/**
 * Network error severity classification strategy
 */

import type { SeverityStrategy, ErrorContext } from './SeverityStrategy.js';
import type { Severity } from '../../types.js';

export class NetworkErrorSeverity implements SeverityStrategy {
  canHandle(context: ErrorContext): boolean {
    return context.type === 'network';
  }

  classify(context: ErrorContext): Severity {
    const statusCode = context.statusCode;

    // CRITICAL: Server errors that indicate system failure
    if (statusCode && (statusCode === 500 || statusCode === 502 || statusCode === 503)) {
      return 'critical';
    }

    // HIGH: Authentication/authorization issues or CORS errors
    if (
      statusCode && (statusCode === 401 || statusCode === 403) ||
      (typeof context.error === 'string' && context.error.includes('CORS'))
    ) {
      return 'high';
    }

    // MEDIUM: Client errors and network failures
    if (
      statusCode === 404 ||
      statusCode === 0 ||
      (typeof context.error === 'string' && (
        context.error.includes('NetworkError') ||
        context.error.includes('fetch failed') ||
        context.error.includes('Failed to fetch')
      ))
    ) {
      return 'medium';
    }

    // LOW: Other network issues
    return 'low';
  }
}

